// firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAKMRgiyBghS1XMQcL-E0wKLWxygbcPiTE",
  authDomain: "hayashi-saudi.firebaseapp.com",
  databaseURL: "https://hayashi-saudi-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "hayashi-saudi",
  storageBucket: "hayashi-saudi.appspot.com",
  messagingSenderId: "995219340485",
  appId: "1:995219340485:web:6ef722fadd3f78279984ac",
  measurementId: "G-QV64E2XSWL"
  // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  // appId: process.env.REACT_APP_FIREBASE_APP_ID,
  // measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const db = getDatabase();
const analytics = getAnalytics(app);

export { app, analytics, db };
